import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import styles from './tab.scss.js';
export class Tab extends CipublicElement {
    constructor() {
        super(...arguments);
        this.isActive = false;
        this.isDisabled = false;
        this.variant = 'horizontal';
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `<li role="presentation"><a @click="${this.clickTab}" data-tab-label="${this.label}" class="tab-item" id="${this.label}-tab" data-toggle="tab" href="#${this.label}" role="tab" aria-selected="${this.isActive}" aria-disabled="${this.isDisabled}" tabindex="${!this.isActive ? '-1' : ''}"><span><slot></slot></span></a></li>`;
    }
    clickTab() {
        if (!this.isDisabled) {
            this.dispatchEvent(new CustomEvent('tabs.click', { bubbles: true, composed: true, cancelable: true }));
        }
    }
}
__decorate([
    property()
], Tab.prototype, "label", void 0);
__decorate([
    property({ type: Boolean, attribute: 'active' })
], Tab.prototype, "isActive", void 0);
__decorate([
    property({ type: Boolean, attribute: 'disabled' })
], Tab.prototype, "isDisabled", void 0);
__decorate([
    property({ reflect: true })
], Tab.prototype, "variant", void 0);
//# sourceMappingURL=tab.js.map